import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OktaAuthGuard, OktaCallbackComponent} from '@okta/okta-angular';
import {HomeComponent} from '@emm/shared/components/home/home.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'menu',
    },
    {
        path: 'login',
        component: HomeComponent,
    },
    {
        path: 'login/callback',
        component: OktaCallbackComponent,
    },
    {
        path: 'management',
        loadChildren: () => import('./management/management.module').then((m) => m.ManagementModule),
        canActivate: [OktaAuthGuard]
    },
    {
        path: 'menu',
        loadChildren: () => import('./menu/menu.module').then((m) => m.MenuModule),
        canActivate: [OktaAuthGuard]
    },
    {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [OktaAuthGuard]
    },
    {
        path: 'common-items',
        loadChildren: () => import('./common-items/common-items.module').then(m => m.CommonItemsModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    useHash: Boolean(history.pushState) === false
}),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
